import { DocumentApi } from "../Repository/eventbookyapi";
import { GetApiConfiguration } from "./ServiceConfiguration";

export abstract class DocumentService {
    public static GetList = async () => {
        return new DocumentApi(GetApiConfiguration()).apiDocumentGet();
    };

    public static Upload = async (file: Blob, overwrite: boolean, folder?: string) => {
        return new DocumentApi(GetApiConfiguration()).apiDocumentPost({ file, overwrite, folder: folder || undefined });
    };

    public static UpdateFolder = async (id: number, folder?: string) => {
        return new DocumentApi(GetApiConfiguration()).apiDocumentIdFolderPatch({ id, folder: folder || undefined });
    };

    public static Delete = async (id: number) => {
        return new DocumentApi(GetApiConfiguration()).apiDocumentIdDelete({ id });
    };

    public static Download = async (id: number) => {
        return new DocumentApi(GetApiConfiguration()).apiDocumentDownloadIdGetRaw({ id });
    };
}
